// --- Modules
import Node, { payload } from './Node';

class LocalService extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Local Service'
    });
  }
};

export default {
  create: (opts) => {
    let item = new LocalService(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
